export const reactContainer = document.getElementById('react-container')
